import React from "react";
import { INK, RED } from "./look";

export const Star = () => (
  <svg width="11.2" height="10.7" viewBox="0 0 11.206 10.657" aria-hidden="true">
    <path fill="#f6310c" transform="translate(-3 -3)"
      d="M8.6,3l1.731,3.508,3.872.566L11.4,9.8l.661,3.855L8.6,11.836,5.14,13.657,5.8,9.8,3,7.073l3.872-.566Z" />
  </svg>
);

export const Clock = () => (
  <svg width="13" height="13" viewBox="0 0 13 13" aria-hidden="true">
    <g transform="translate(-2.4 -2.4)" fill="none" stroke={INK} strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.2">
      <path d="M13.929,8.465A5.465,5.465,0,1,1,8.465,3,5.465,5.465,0,0,1,13.929,8.465Z" />
      <path d="M18,9v3.279l2.186,1.093" transform="translate(-9.535 -3.814)" />
    </g>
  </svg>
);

export const Pin = () => (
  <svg width="17" height="20.5" viewBox="0 0 17.045 20.5" aria-hidden="true">
    <g transform="translate(0.75 0.75)" fill="none" stroke={RED} strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5">
      <path d="M20.045,9.273c0,6.045-7.773,11.227-7.773,11.227S4.5,15.318,4.5,9.273a7.773,7.773,0,1,1,15.545,0Z" transform="translate(-4.5 -1.5)" />
      <path d="M18.682,13.091A2.591,2.591,0,1,1,16.091,10.5a2.591,2.591,0,0,1,2.591,2.591Z" transform="translate(-8.318 -5.318)" />
    </g>
  </svg>
);

export const Chevron = () => (
  <svg width="17" height="17" viewBox="0 0 24 24" aria-hidden="true">
    <path fill={RED} d="M8.59 16.59 13.17 12 8.59 7.41 10 6l6 6-6 6z" />
  </svg>
);

export const BackArrow = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" aria-hidden="true">
    <path fill={INK} d="M20 11H7.83l5.59-5.59L12 4l-8 8 8 8 1.41-1.41L7.83 13H20z" />
  </svg>
);
